import { PayinOrderPublicStatus } from '~/entities/payin';

export const filters = {
    publicStatuses: [PayinOrderPublicStatus.PUBLIC_STATUS_CREATED, PayinOrderPublicStatus.PUBLIC_STATUS_PENDING],
};
